import { Component, OnInit, Inject } from '@angular/core';
import { environment } from 'src/environments/environment';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CommonService } from 'src/app/services/common.service';

@Component({
  selector: 'app-loading-information',
  templateUrl: './loading-information.component.html',
  styleUrls: ['./loading-information.component.scss'],
})
export class LoadingInformationComponent implements OnInit {
  RESOURCE_SERVER_URL = environment.RESOURCE_SERVER_URL;
  isLoading: boolean = false;
  loadingInformation = [];
  viewExclusion: boolean = false;
  exclusionList: any;
  currencyCode
  constructor(
    private commonService: CommonService,
    private dialogRef: MatDialogRef<LoadingInformationComponent>,
    @Inject(MAT_DIALOG_DATA) public data
  ) { }

  async ngOnInit() {
    this.currencyCode=localStorage.getItem('currency')
    this.isLoading = true;
    this.loadingInformation = this.commonService.claimReviewPolicyDetails['coverages'];
    console.log('loadingInformation', this.loadingInformation);
    this.isLoading = false;
  }

  stringToNumber(value) {
    let number = 0;
    number = Number(value);
    return number.toFixed(2);
  }
  calculateTax(preminum, preminumWithTax) {
    let tax = 0;
    tax = Number(preminumWithTax) - Number(preminum);
    return tax.toFixed(2);
  }

  totalAmount(covers, fieldname, key) {
    let totalsume = 0;
    covers.map(cover => {
      if (cover != undefined) {
        totalsume += this.calculateCor(cover, fieldname, key);
      }
      if (cover.riders != undefined) {
        if (cover.riders.length != 0) {
          cover.riders.map(rider => {
            totalsume += this.calculateRid(cover, rider, fieldname, key);
          })
        }
      }
    })
    return totalsume.toFixed(2);
  }
  
  calculateCor(cover, fieldname, key) {
    if (key === 'TAX') {
      return (Number(cover['coverageAnnualPremiumWithTax']) - Number(cover['coveragePremium']));
    } else if (key === 'L') {
      if (cover.loadings != undefined) {
        if (cover.loadings.length != 0) {
          let getValueByField = this.getValueByFieldName(fieldname, cover);
          return (Number(getValueByField));
        }
      }
    } else {
      return this.getValueCor(cover, fieldname);
    }
  }

  getValueByFieldName(fieldname, cover) {
    let getFieldName;
    switch(fieldname) {
      case 'A':
        getFieldName = 'ageRating';
        break;
      case 'RA':
        getFieldName = 'rateAdjustment';
        break;
      case 'PL':
        getFieldName = 'loadPercent';
        break;
      case 'PA':
        getFieldName = 'premiumAdjusted';
        break;
      case 'FM':
        getFieldName = 'flatMortality';
        break;
      default:
        getFieldName = 'duration';
    }
    return cover.loadings[0][getFieldName];
  }

  getValueCor(cover, fieldname) {
    let getFieldName;
    switch(fieldname) {
      case 'SA':
        getFieldName = 'coverageSumInsured';
        break;
      case 'P':
        getFieldName = 'coveragePremium';
        break;
      case 'TP':
        getFieldName = 'coverageAnnualPremiumWithTax';
        break;
      default:
        getFieldName = '';
    }
    return (Number(cover[getFieldName]));
  }

  calculateRid(cover, rider, fieldname, key) {
    if (key === 'TAX') {
      return (Number(rider['riderAnnualPremiumWithTax']) - Number(rider['riderPremium']));
    } else if (key === 'L') {
      if (cover.loadings != undefined) {
        if (cover.loadings.length != 0) {
          let getValueByField = this.getValueByFieldName(fieldname, cover);
          return (Number(getValueByField));
        }
      }
    } else {
      let valueTemp = this.getValueRid(rider, fieldname);
      return valueTemp;
    }
  }

  getValueRid(rider, fieldname) {
    let getFieldName;
    switch(fieldname) {
      case 'SA':
        getFieldName = 'riderSumInsured';
        break;
      case 'P':
        getFieldName = 'riderPremium';
        break;
      case 'TP':
        getFieldName = 'riderAnnualPremiumWithTax';
        break;
      default:
        getFieldName = '';
    }
    return (Number(rider[getFieldName]));
  }

  onClose() {
    this.dialogRef.close();
  }

  showExclusion(data) {
    console.log('data: ', data)
    if(data.exclusion != undefined && data.exclusion != null){
      this.exclusionList = data.exclusion;
    }else{
      this.exclusionList = []
    }
    this.viewExclusion=!this.viewExclusion
  }
  closeExclusion(){
    this.viewExclusion=!this.viewExclusion
  }
}
